<template>
    <div>
        <innerheader />
        <proposaladdresscheck />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheader from "@/components/innerheader/innerheader.vue";
import proposaladdresscheck from "@/components/proposal/proposal-details-check.vue";

export default {
  name:' proposaldetailscheck',
  components: {
     innerheader,
     proposaladdresscheck
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/checkout.scss';
@import '~@/assets/scss/components/proposal-page.scss';
</style>